module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av371-498379ca896c8596d68322015f3bbd71.jpg";